/*****************************************************************************
 * PROJECT NAME   : SEC 회의실관리 프로젝트
 * SUBSYSTEM NAME : Admin
 * FILE NAME      : index.js
 * DESCRIPTION    : VUEX 스토어 파일
 *
 * VERSION NO     author           date        content  -> info
 * ----------------------------------------------------------------------------
 *    1.0       K.Hur      2021-09-27      init
 *****************************************************************************/

import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state () {
    return {
      isLoading: false,
      headerShow: true,
      ADMIN_NO: '',
      ADMIN_ID: '',
      IS_SUPER: '',
      ADMIN_NM: '',
      LAST_LOGIN_DT: '',
      g_url: '',
      accesstoken: '',
      refreshtoken: '',
    }
  },
  mutations: {
    showLoading () {
      this.state.isLoading = true;
    },
    hideLoading () {
      this.state.isLoading = false;
    },
    showHeader () {
      this.state.headerShow = true;
    },
    hideHeader () {
      this.state.headerShow = false;
    },

    SET_ADMIN_NO(state, no){
      state.ADMIN_NO = no
    },
    SET_ADMIN_ID(state, id){
      state.ADMIN_ID = id
    },
    SET_IS_SUPER(state, is){
      state.IS_SUPER = is
    },
    SET_ADMIN_NM(state, nm){
      state.ADMIN_NM = nm
    },
    SET_accesstoken(state, token){
      state.accesstoken = token
    },
    SET_refreshtoken(state, token){
      state.refreshtoken = token
    },

  },
  actions: {
  },
  modules: {
  },

  plugins:[
    createPersistedState()
  ],

})
